var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmartLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 48,
    viewBox: "0 0 132 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.62025 19.8232C-0.556689 22.0861 -0.537556 25.7101 1.66315 27.949C3.86385 30.1879 7.42595 30.2074 9.65017 27.9926L23.4966 13.9057C24.9568 12.4517 25.5366 10.3117 25.0149 8.30191C24.4931 6.29213 22.9503 4.72248 20.9748 4.19167C18.9993 3.66085 16.8958 4.25072 15.4667 5.73629L1.62025 19.8232Z",
    fill: "url(#paint0_linear_186_152)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51026 34.0513C6.04417 35.5116 5.46203 37.6609 5.98589 39.6794C6.50974 41.6979 8.05881 43.2744 10.0423 43.8075C12.0257 44.3406 14.1376 43.7482 15.5726 42.2562L29.4775 28.108C31.5623 25.8221 31.4983 22.2679 29.3328 20.0611C27.1672 17.8543 23.6749 17.7845 21.4259 19.9031L7.51026 34.0513Z",
    fill: "url(#paint1_linear_186_152)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68937 18.1026C2.54722 18.1026 2.96266e-08 20.6855 2.96266e-08 23.8718C2.96266e-08 27.0581 2.54722 29.641 5.68937 29.641H25.3106C28.4528 29.641 31 27.0581 31 23.8718C31 20.6855 28.4528 18.1026 25.3106 18.1026H5.68937Z",
    fill: "url(#paint2_linear_186_152)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132 21.8929V17.7492H127.365V13H126.633L118.749 21.138V21.8929H122.763V29.3397C122.763 32.8437 124.395 35 128.083 35C129.454 35 131.086 34.6629 131.967 34.0904V30.1481C131.249 30.5191 130.466 30.7544 129.584 30.7544C128.05 30.7544 127.365 30.0805 127.365 28.3963V21.8929H132ZM111.044 20.5793V17.7492H106.442V34.5621H111.044V24.7573C111.632 23.4095 113.395 21.826 115.81 21.826C116.3 21.826 116.789 21.8599 117.246 21.9948V17.3448C117.05 17.3113 116.887 17.3113 116.724 17.3113C114.178 17.3113 111.925 18.9286 111.044 20.5793ZM97.9863 28.3286C97.3006 29.6764 95.8317 30.8559 93.9386 30.8559C91.3595 30.8559 89.5316 28.8007 89.5316 26.1389C89.5316 23.5106 91.3595 21.4555 93.9386 21.4555C95.8317 21.4555 97.3006 22.6349 97.9863 23.9489V28.3286ZM97.9863 19.8043C97.0719 18.5915 95.3747 17.3113 92.6329 17.3113C88.1283 17.3113 84.9618 21.2194 84.9618 26.1389C84.9618 31.0915 88.1283 35 92.6329 35C95.3747 35 97.0719 33.7533 97.9863 32.5066V34.5621H102.588V17.7492H97.9863V19.8043ZM76.3761 17.3113C73.8953 17.3113 71.8063 18.6253 70.7616 20.1753C70.1088 18.7264 68.2808 17.3113 65.7021 17.3113C63.4172 17.3113 61.72 18.4569 60.7409 19.8043V17.7492H56.1384V34.5621H60.7409V23.8816C61.361 22.6683 62.7647 21.6577 64.168 21.6577C65.3107 21.6577 66.8775 22.1632 66.8775 25.1283V34.5621H71.4797V23.9489C72.0674 22.7022 73.4383 21.6577 74.8744 21.6577C76.0171 21.6577 77.5839 22.1294 77.5839 25.1283V34.5621H82.1864V24.0496C82.1864 19.5014 79.738 17.3113 76.3761 17.3113ZM47.8129 24.4206C45.7567 23.915 43.7657 23.7128 43.7657 22.4999C43.7657 21.6911 44.5817 21.1521 46.3768 21.1521C48.5965 21.1521 50.8162 22.0283 52.2851 22.9044V18.8609C50.8162 17.918 48.4006 17.3113 46.1813 17.3113C41.6763 17.3113 39 19.2654 39 22.4661C39 25.5996 40.8279 26.7452 44.2878 27.6886C46.6707 28.3625 48.4662 28.5308 48.4662 29.7103C48.4662 30.6202 47.4539 31.1254 45.6588 31.1254C42.721 31.1254 40.175 30.0136 39 29.2048V33.4165C40.4689 34.3595 43.08 35 45.8547 35C50.2941 35 53.1339 32.8437 53.1339 29.7441C53.1339 26.6779 51.1425 25.229 47.8129 24.4206Z",
    fill: "#5032C8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_186_152",
    x1: 15.4488,
    y1: 58.7985,
    x2: 49.0728,
    y2: 32.7399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#236EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#13A6C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#05D6DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_186_152",
    x1: 15.6234,
    y1: 58.7168,
    x2: 49.3828,
    y2: 32.5452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#5032C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#4C44C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#4175B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#2FC1A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#28E1A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_186_152",
    x1: 0,
    y1: 29.6405,
    x2: 30.9973,
    y2: 29.6405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0096DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#0BABCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#18C3B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#21D4AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#26DEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28E1A0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartLogo);
export default __webpack_public_path__ + "static/media/smart-logo.2643eda07e7ded62d2cc6c6b96f925bd.svg";
export { ForwardRef as ReactComponent };